function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.361,
    height: 17.93,
    viewBox: "0 0 22.361 17.93",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2446"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 2949",
    style: {
      fill: "none",
      strokeLinecap: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.005 1.005h20.351",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.356 2.01H1.005A1.002 1.002 0 0 1 0 1.005 1.003 1.003 0 0 1 1.005 0h20.351a1.002 1.002 0 0 1 1.005 1.005 1.002 1.002 0 0 1-1.005 1.005z",
    style: {
      fill: "#000",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 2950",
    style: {
      fill: "none",
      strokeLinecap: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.005 1.005h20.351",
    style: {
      stroke: "none"
    },
    transform: "translate(0 7.96)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.356 2.01H1.005A1.002 1.002 0 0 1 0 1.005 1.003 1.003 0 0 1 1.005 0h20.351a1.002 1.002 0 0 1 1.005 1.005 1.002 1.002 0 0 1-1.005 1.005z",
    style: {
      fill: "#000",
      stroke: "none"
    },
    transform: "translate(0 7.96)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 2951",
    style: {
      fill: "none",
      strokeLinecap: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.005 1.005h20.351",
    style: {
      stroke: "none"
    },
    transform: "translate(0 15.92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.356 2.01H1.005A1.002 1.002 0 0 1 0 1.005 1.003 1.003 0 0 1 1.005 0h20.351a1.002 1.002 0 0 1 1.005 1.005 1.002 1.002 0 0 1-1.005 1.005z",
    style: {
      fill: "#000",
      stroke: "none"
    },
    transform: "translate(0 15.92)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-menu.94ff8c33f47c44697d6be06987aab9af.svg";